import { createAction } from "@reduxjs/toolkit";
import { Biller } from "../billers/billerTypes";

// type PayloadAction<T> = { type: string; payload: T };
// type ActionCreator<T> = (payload: T) => PayloadAction<T>;
// type ActionType<T> = ActionCreator<T> & { type: string };
// type ActionMap = Record<string, ActionType<any>>;

// type startProcessPayload = {
//   billerId: string;
//   values: {
//     billerId: string | string[];
//     cardLast4Digits: string;
//     MobileNumber: string;
//     RegisterMobile: string;
//   };
// };
// export const startProcess = createAction<startProcessPayload>(
//   "billerDetails/startProcess"
// );

// src/types/billFetch.ts
export type CustomerParams = Record<string, string>;
export type CustomerDetails = Record<string, string>;

export interface BillFetchRequestBody {
  refId: string;
  agentId: string;
  billerId: string;
  customerMobileNumber: string;
  customerParams: CustomerParams; // dynamic keys (labels from API)
  customerDetails: CustomerDetails; // dynamic keys (EMAIL, etc.)
  deviceDetails: { MAC: string; IP: string };
  timeStamp: string; // ISO with timezone, e.g. 2025-09-26T17:02:00+05:30
}

export const startProcess = createAction<{ billerId: string; values: any }>(
  "billerDetails/startProcess",
);

export const billerDetailsSuccess = createAction<Biller>(
  "billerDetails/success",
);
export const billerDetailsFailure = createAction<string>(
  "billerDetails/failure",
);

export const fetchPlansSuccess = createAction<any>(
  "billerDetails/plansSuccess",
);
export const billFetchSuccess = createAction<any>("billerDetails/fetchSuccess");
export const billValidationSuccess = createAction<any>(
  "billerDetails/validationSuccess",
);
export const billPaymentSuccess = createAction<any>(
  "billerDetails/paymentSuccess",
);

export const processFailure = createAction<string>(
  "billerDetails/processFailure",
);

export const billContextSaved = createAction<{
  refId: string;
  billerId: string;
  approvalRefNum: string;
  customerMobileNumber: string;
  customerParams: Record<string, string>;
}>("billerDetails/billContextSaved");
